<template>
  <div class="inputGai">
    <el-date-picker
      style="width: 100%"
      v-model="innerValue[0]"
      :type="renderConfig.type"
      :format="renderConfig.dateFormat"
      :value-format="renderConfig.dateFormat"
      :placeholder="renderConfig.placeholder"
      :start-placeholder="renderConfig.startDatePlaceholder"
      :disabled="renderConfig.disabled"
      :end-placeholder="renderConfig.endDatePlaceholder"
      range-separator="-"
      @change="val => handleChange(val, 0)"
    />
    <el-time-picker
      v-model="innerValue[1]"
      is-range
      range-separator="-"
      :valueFormat="renderConfig.timeFormat"
      :format="renderConfig.timeFormat"
      :start-placeholder="renderConfig.startTimePlaceholder"
      :end-placeholder="renderConfig.endTimePlaceholder"
      :disabled="renderConfig.disabled"
      style="flex-grow: 1; width: 100%; margin-left: 12px"
      :default-value="
        new Date(dayjs().hour() - 2, dayjs().minute(), 0, dayjs().hour() - 1, dayjs().minute(), 0)
      "
      @change="val => handleChange(val, 1)"
    />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { basicProps } from '@/components/custom/form/components/props'
import dayjs from 'dayjs'
import { isString } from '@/utils/is'
const props = defineProps({
  ...basicProps
})
const emit = defineEmits(['update:modelValue'])

const innerValue = computed({
  get() {
    if (isString(props.modelValue)) {
      const arrVal = props.modelValue.split(',')
      if (arrVal.length) {
        const [startDate, endDate, startTime, endTime] = arrVal
        return [
          [startDate || null, endDate || null],
          [startTime, endTime]
        ]
      }
      return [
        [null, null],
        [null, null]
      ]
    }

    return props.modelValue
  },
  set(newVal) {
    emit('update:modelValue', newVal)
  }
})

function handleChange(value: Recordable, sign: number) {
  if (!value || !value.length) {
    innerValue.value[sign] = [null, null]
  }
  emit('update:modelValue', innerValue.value)
}
</script>
<style lang="scss" scoped>
.inputGai {
  display: flex;
  align-items: center;
  .separate {
    padding: 0 4px;
  }
}
</style>
